<template>
  <HeaderTitle single :back-target-func="backToFeed">
    <template #bottom>
      <span v-if="category">
        {{ name }}
      </span>
      <span v-else-if="type && type === ArticleType.BKK">
        {{ t("feed.category.sections.for.me.bkk.tile.title") }}
      </span>
      <span v-else-if="type && type === ArticleType.COMPANY">
        {{ t("feed.category.sections.for.me.company.tile.title") }}
      </span>
    </template>
  </HeaderTitle>
  <div v-if="category">
    <div
      v-for="categoryData in articlesCategory"
      :key="categoryData.categoryId"
    >
      <ArticleGrid v-if="category" :articles="categoryData.articles" />
    </div>
  </div>
  <div v-else-if="type">
    <ArticleGrid :articles="articlesType" />
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ArticleDto } from "../../dto/article.dto";
import { ArticleType } from "../../enum/v2/articleType.ts";
import { useArticleStore } from "../../store/v2/article";
import ArticleGrid from "../../components/v2/article/ArticleGrid.vue";
import { useI18n } from "vue-i18n";
import HeaderTitle from "../../components/v2/layout/header/HeaderTitle.vue";

const { t } = useI18n();

const route = useRoute();
const router = useRouter();
const articleStore = useArticleStore();
const category = route.params.category;
const name = route.params.name;
const type = route.params.type;
const articlesCategory = ref<{ categoryId: string; articles: ArticleDto[] }[]>(
  []
);
const articlesType = ref<ArticleDto[]>([]);
onMounted(async () => {
  if (category) {
    articlesCategory.value =
      await articleStore.getArticlesForCategory(category);
  } else if (type) {
    articlesType.value = await articleStore.getArticlesForType(type);
  }
});

function backToFeed() {
  router.push({ name: "feed", state: { fromFavorite: true } });
}
</script>
